import RequestBehaviour from '../base/RequestBehaviour';

export default class CaptureTransaction extends RequestBehaviour {
	/**
	 * Payment UUID
	 */
	payment_uuid?: string = undefined;

	/**
	 * The total amount to capture, equal to or less than the authorized amount.
	 */
	transaction_approved_amount?: string = undefined;

	/**
	 * Tap to pay device serial code
	 */
	tap_to_pay_device?: string = undefined;

	/**
	 * Capture Transaction with tap to pay
	 */
	tap_to_pay_request: boolean = false;

	/**
	 * Enable Tap to Pay request
	 */
	withTap2Pay(device?: string) {
		this.tap_to_pay_request = true;

		if (device) {
			this.tap_to_pay_device = device;
		}
	}
}

